<script>
    import { RichTextEditor } from "../../../Components/Common/index.svelte";

    export let topHeaderConfig = {};
    export let editorRef;
</script>

<div class="flex flex-col gap-y-2">
    <p class="text-lg font-bold">Header:</p>

    <RichTextEditor
        bind:this={editorRef}
        bind:content={topHeaderConfig.content}
    />
</div>

<style>
    img {
        max-width: 280px;
        max-height: 140px;
    }
</style>
